var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailedHelpGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71914 7.2402L7.18934 7.77106L8.25106 8.83066L8.78086 8.2998L8.25 7.77L7.71914 7.2402ZM15.256 0.75L15.7869 1.2798C16.0011 1.06519 16.065 0.742714 15.9488 0.462642C15.8326 0.18257 15.5592 0 15.256 0V0.75ZM8.25 7.77L8.78086 8.2998L15.7869 1.2798L15.256 0.75L14.7252 0.220199L7.71914 7.2402L8.25 7.77ZM15.256 0.75V0H9.64841V0.75V1.5H15.256V0.75Z",
    fill: "#005B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0059 0.75V0H14.5059V0.75H15.2559H16.0059ZM15.2559 0.75H14.5059V6.35761H15.2559H16.0059V0.75H15.2559Z",
    fill: "#005B90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.75H0.75V14.75H15.25V8.25",
    stroke: "#005B90",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedHelpGuide);
export default __webpack_public_path__ + "static/media/detailed-help-guide.9f37e1a854dedecb233d29ca759d4f65.svg";
export { ForwardRef as ReactComponent };